import { z } from 'zod';

export const refParamsSchema = z.object({
  code: z.string().min(1, 'Le code ne doit pas être vide').max(20, 'Le code ne doit pas dépasser 20 caractères'),
  description: z.string().min(1, 'La description ne doit pas être vide').max(250, 'La description ne doit pas dépasser 250'),
  refTypeId: z.number({ required_error: 'ce champs est obligatoire' }),
});
